class CollectionProduct extends HTMLElement {
  constructor() {
    super();

    this.productItem = this.querySelector(".js-collection-product-item");
    this.clickReg = null;
    this.slidesWrapper = this.querySelector(".js-images-container");
    this.slidesWrapper.classList.add("slider-mode");
    const prev = this.querySelector(".slider-btn--prev");
    const next = this.querySelector(".slider-btn--next");

    const coverImage = this.slidesWrapper.getAttribute("data-cover-image");

    this.swiperInstance = new Swiper(this.slidesWrapper, {
      initialSlide: coverImage ? Number(coverImage) - 1 : 0,
      slidesPerView: 1,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      loop: true,
    });

    this.enableHover = this.enableHover.bind(this);
    this.disableHover = this.disableHover.bind(this);
    this.toggleHover = this.toggleHover.bind(this);
    this.clickPDown = this.clickPDown.bind(this);
    this.clickPUp = this.clickPUp.bind(this);
    this.fadeIn = this.fadeIn.bind(this);

    this.productItem.addEventListener("pointerdown", this.clickPDown);
    this.productItem.addEventListener("pointerup", this.clickPUp);
    this.productItem.addEventListener("mouseenter", this.enableHover);
    this.productItem.addEventListener("mouseleave", this.disableHover);
    this.productItem.addEventListener("touchstart", this.enableHover);
    this.productItem.addEventListener("touchend", this.disableHover);

    window.addEventListener("custom:products-fade-in", this.fadeIn);
    this.fadeIn();
  }

  fadeIn() {
    const lazyLoadedImage = this.querySelector(".--img-loading");
    if (
      lazyLoadedImage &&
      this.getBoundingClientRect().top < window.innerHeight
    ) {
      lazyLoadedImage.classList.remove("--img-loading");
    }
  }

  enableHover() {
    this.toggleHover(true);
  }

  disableHover() {
    this.toggleHover(false);
  }

  toggleHover(state) {
    const target = this.productItem;
    if (state) {
      target.classList.add("--hovered");
    } else {
      target.classList.remove("--hovered");
    }
  }

  clickPDown(e) {
    const plt = window?.navigator?.userAgent;
    if (
      ["iPhone", "iPad", "iPod"].some((item) => plt.includes(item)) &&
      !this.clickreg
    ) {
      this.clickreg = {
        timeout: setTimeout(() => {
          clearTimeout(this.clickreg.timeout);
          this.clickreg = null;
        }, 150),
        pos: {
          x: e.clientX,
          y: e.clientY,
        },
      };
    }
  }

  clickPUp(e) {
    if (
      e.target.closest(".swiper-buttons") ||
      e.target.classList.contains(".swiper-buttons")
    )
      return;
    if (this.clickreg) {
      if (
        e.clientX === this.clickreg.pos.x &&
        e.clientY === this.clickreg.pos.y
      )
        window.location.href = `/products/${product.handle}`;
    }
  }
}

customElements.define("collection-product", CollectionProduct);

class InfiniteCollections extends HTMLElement {
  constructor() {
    super();

    this.loadingIndicator = document.querySelector(".js-page-top-loader");
    this.loadingIndicator?.classList.remove("--active");
    this.grid = this.querySelector(".js-custom-collection-grid");
    this.pages = this.grid.getAttribute("data-pages");
    this.url = this.grid.getAttribute("data-url");
    this.currentPage = 1;
    this.fetching = false;

    this.detectPageEnd = this.detectPageEnd.bind(this);
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.update = this.update.bind(this);

    window.addEventListener("scroll", this.detectPageEnd);
    window.addEventListener("custom:filters_updated", this.update);

    const mobileViewToggle = this.querySelector(".js-toggle-mobile-view");
    mobileViewToggle?.addEventListener("click", this.toggleMobileView);
  }

  detectPageEnd() {
    const bottom = this.getBoundingClientRect().bottom;
    if (
      bottom < window.innerHeight + 200 &&
      this.currentPage < this.pages &&
      !this.fetching
    ) {
      this.fetchNextPage();
    }
  }

  fetchNextPage() {
    if (this.fetching) return;
    this.fetching = true;
    this.loadingIndicator?.classList.add("--active");

    const url = encodeURI(`${this.url}?page=${this.currentPage + 1}`);
    this.currentPage++;

    fetch(url)
      .then((res) => res.text())
      .then((data) => {
        const parser = new DOMParser();
        const container = parser.parseFromString(data, "text/html");

        const products = container.querySelectorAll("collection-product");
        if (products.length) {
          products.forEach((product) => {
            this.grid.appendChild(product);
          });
        }

        this.loadingIndicator?.classList.remove("--active");
        this.fetching = false;
      });
  }

  update(e) {
    if (this.fetching) return;
    this.fetching = true;
    this.loadingIndicator?.classList.add("--active");

    const { sort_by, colors } = e.detail;
    const color_filters = colors
      .map((color) => `filter.p.tag=${color}`)
      .join("&");
    const url = `${this.url}${sort_by ? `?sort_by=${sort_by}` : ""}${
      color_filters ? `${sort_by ? "&" : "?"}${color_filters}` : ""
    }`;

    fetch(url)
      .then((res) => res.text())
      .then((data) => {
        const parser = new DOMParser();
        const container = parser.parseFromString(data, "text/html");

        const newGrid = container.querySelector("infinite-collections");
        newGrid.setAttribute(
          "data-filters-open",
          this.getAttribute("data-filters-open")
        );

        const colContainer = this.querySelector(".collection-default");
        const currentView = colContainer.classList.contains("view-by-four")
          ? "view-by-four"
          : colContainer.classList.contains("view-thumb-grid")
          ? "view-thumb-grid"
          : "view-by-two";
        const newColContainer = newGrid.querySelector(".collection-default");
        newColContainer.classList.remove(
          "view-by-two",
          "view-by-four",
          "view-thumb-grid"
        );
        newColContainer.classList.add(currentView);
        window.scrollTo({ top: 0 });
        this.parentElement.replaceChild(newGrid, this);
      });
  }

  toggleMobileView() {
    const collectionDefault = document.querySelector(".collection-default");
    if (!collectionDefault) return;

    const two = document.querySelector(".collection-default.view-by-two");
    const four = document.querySelector(".collection-default.view-by-four");
    const viewBy = two
      ? "view-by-four"
      : four
      ? "view-thumb-grid"
      : "view-by-two";

    collectionDefault.classList.remove(
      "view-by-two",
      "view-by-four",
      "view-thumb-grid"
    );
    collectionDefault.classList.add(viewBy);

    if (window.scrollY > 0) {
      window.scrollTo({ top: 0 });
    } else {
      const event = new CustomEvent("custom:products-fade-in");
      window.dispatchEvent(event);
    }
  }
}

customElements.define("infinite-collections", InfiniteCollections);

class CustomCollectionFilters extends HTMLElement {
  constructor() {
    super();

    const original = document.querySelector("header .filter-by");
    const custom = this.querySelector("details");

    this.collectionWrapper = this.closest("infinite-collections");
    if (this.collectionWrapper.getAttribute("data-filters-open") === "true")
      custom.open = true;

    this.inputs = [];
    this.inputs.push(...this.querySelectorAll('input[name="sort_by"]'));
    this.inputs.push(...this.querySelectorAll('input[name="color"]'));

    this.inputs.forEach((input, idx) => {
      input.addEventListener("change", () => {
        if (idx === 0) {
          this.inputs[1].checked = false;
        } else if (idx === 1) {
          this.inputs[0].checked = false;
        }
        const sort_by =
          this.inputs.find((input) => input.name === "sort_by" && input.checked)
            ?.value || "";
        const colors = this.inputs
          .filter((input) => input.name === "color" && input.checked)
          .map((input) => input.value);

        const event = new CustomEvent("custom:filters_updated", {
          detail: { sort_by, colors },
        });

        this.collectionWrapper.setAttribute("data-filters-open", custom.open);

        window.dispatchEvent(event);
      });
    });

    this.clearBtn = this.querySelector(".js-cc-filters-clear");
    this.clearBtn?.addEventListener("click", () => {
      this.inputs.forEach((input) => {
        input.checked = false;
        const event = new CustomEvent("custom:filters_updated", {
          detail: {
            sort_by: "",
            colors: [],
          },
        });

        this.collectionWrapper.setAttribute("data-filters-open", custom.open);

        window.dispatchEvent(event);
      });
    });

    if (custom.classList.contains("--desktop")) {
      original.parentElement.replaceChild(custom, original);
      this.parentElement.removeChild(this);
    }
  }
}

customElements.define("cc-filters", CustomCollectionFilters);
